export const AGENCY_CONFIG_STATE_NAME = 'agencyConfig';
